export enum Action {
    None = 0,
    ChangeOrderType = 1,
    ChangePage = 2,
    ChangeSupplier = 3,
    ChangeDeliveryDate = 4,
}